import { render } from "./AppLayoutAuth.vue?vue&type=template&id=ca948356&scoped=true&ts=true"
import script from "./AppLayoutAuth.vue?vue&type=script&lang=ts"
export * from "./AppLayoutAuth.vue?vue&type=script&lang=ts"

import "./AppLayoutAuth.vue?vue&type=style&index=0&id=ca948356&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca948356"]])

export default __exports__